class Rule {
    name;
    text;
    native;
    constructor(name, text){
        this.name = name;
        this.text = text;
    }
    get key() {
        return this.name;
    }
}

export { Rule };
